
import { ContactForm } from "./components/contact-form/contact-form";

document.addEventListener('DOMContentLoaded', function() {

	new ContactForm();

}, false);